import EFVideoModal from '@/components/UI/EFVideoModal';
import { useGlobal } from '@/utils/useGlobal';
import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';

export default function A() {
    const { useLang, useRouter, useState } = useGlobal();
    const { t } = useLang('loadshedding');
    const { locale } = useRouter();
    const [showVideo, setShowVideo] = useState(false);
    const VIDEO_SOURCE = 'https://www.youtube.com/embed/XttMpbQeI5k?si=BgRWxX8Y6OHamuDW';

    return (
        <div className={`load-shedding-A ${css['load-shedding-A']}`}>
            <EFPicture
                src={'https://websiteoss.ecoflow.com/upload/image/1746605430534/pc.jpg'}
                srcDesktop={'https://websiteoss.ecoflow.com/upload/image/1746605430370/m.jpg'}
                srcMobile={'https://websiteoss.ecoflow.com/upload/image/1746605430370/m.jpg'}
                alt={t('secA_title')}
            />
            <div className="banner-box">
                <h1 className="banner-title">{t('secA_title')}</h1>
                <p className="banner-desc">{t('secA_desc')}</p>
                <button className="banner-play-btn" onClick={() => setShowVideo(true)}>
                    <span className="play-text">{t('secA_btn')}</span>
                    <svg className="play-icon" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <path
                            d="M9.25833 1.09575C13.8149 1.09575 17.5088 4.78961 17.5088 9.34622C17.5088 13.9028 13.8149 17.5967 9.25833 17.5967C4.70172 17.5967 1.00786 13.9028 1.00786 9.34622C1.00786 4.78961 4.70172 1.09575 9.25833 1.09575Z"
                            stroke="white"
                            strokeWidth="1.50009"
                        />
                        <path
                            d="M7.31393 5.25586C7.0316 5.25586 6.80273 5.48473 6.80273 5.76705V12.9269C6.80273 13.0212 6.82883 13.1137 6.87814 13.1941C7.02573 13.4348 7.34048 13.5103 7.58115 13.3627L13.4192 9.78275C13.4879 9.74063 13.5456 9.68288 13.5877 9.61419C13.7353 9.37352 13.6598 9.05877 13.4192 8.91118L7.58115 5.33127C7.50074 5.28196 7.40825 5.25586 7.31393 5.25586Z"
                            fill="white"
                        />
                    </svg>
                </button>
            </div>
            {showVideo && (
                <EFVideoModal
                    visible={showVideo}
                    source={VIDEO_SOURCE}
                    onClose={() => setShowVideo(false)}
                    playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
                />
            )}
        </div>
    );
}
